module.exports = btmShared.dssDevice;